import Svg, {
  Circle,
  Path,
  type PathProps,
  type SvgProps,
} from 'react-native-svg'

/** Lucide grape geometry for viewBox 0 0 24 24. */
export function LucideGrapePaths() {
  return (
    <>
      <Path d="M22 5V2l-5.89 5.89" />
      <Circle cx="16.6" cy="15.89" r="3" />
      <Circle cx="8.11" cy="7.4" r="3" />
      <Circle cx="12.35" cy="11.65" r="3" />
      <Circle cx="13.91" cy="5.85" r="3" />
      <Circle cx="18.15" cy="10.09" r="3" />
      <Circle cx="6.56" cy="13.2" r="3" />
      <Circle cx="10.8" cy="17.44" r="3" />
      <Circle cx="5" cy="19" r="3" />
    </>
  )
}

/**
 * Lucide "grape" mark (stroke), viewBox 0 0 24 24.
 * @see https://lucide.dev/icons/grape
 */
export function GrapeIcon({
  fill = '#C22EFF',
  ...rest
}: {fill?: PathProps['fill']} & SvgProps) {
  // @ts-ignore
  const size = parseInt(`${rest.width || 64}`, 10)

  return (
    <Svg
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
      width={size}
      height={size}
      stroke={fill}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round">
      <LucideGrapePaths />
    </Svg>
  )
}
